import { render } from "./routerViewAdmin.vue?vue&type=template&id=f8d6758a"
import script from "./routerViewAdmin.vue?vue&type=script&lang=js"
export * from "./routerViewAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__